import { useToast } from 'vue-toastification'
import dayjs from 'dayjs'
import { detailedDiff } from 'deep-object-diff'
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

const toast = useToast()

const THIS_YEAR = new Date().getFullYear()
const THIS_YEAR_UNIXTS = dayjs(THIS_YEAR, 'YYYY').unix()

const µUtils: any = {
	dayjs,

	cp(v: any) {
		return JSON.parse(JSON.stringify(v))
	},

	round(num: number) {
		Math.round(num * 100) / 100
	},

	µ_toast(info: string) {
		toast(info)
	},
	µ_error(info: string) {
		toast.error(info)
	},
	µ_success(info: string) {
		toast.success(info)
	},

	µ_toHumanFileSize(bytes: any) {
		const thresh = 1024
		if (Math.abs(bytes) < thresh) {
			return bytes + ' B'
		}
		const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
		let u = -1
		do {
			bytes /= thresh
			++u
		} while (Math.abs(bytes) >= thresh && u < units.length - 1)
		return bytes.toFixed(1) + ' ' + units[u]
	},

	µ_diff(obj1 = {}, obj2 = {}) {
		const difference: any = detailedDiff(obj1, obj2)
		// window.LOG.pink('deleted', difference.deleted);

		const diffs: any =
			Object.keys(difference.updated).length +
			Object.keys(difference.deleted).length +
			Object.keys(difference.added).length

		return { ...difference, isChanged: diffs > 0 }
		//   difference.updated,
		//   difference.deleted,
		//   difference.added
		// ]
	},

	µ_compareVersion(a: string, b: string) {
		if (a === b) {
			return 0
		}
		const aComponents = a.split('.')
		const bComponents = b.split('.')
		const len = Math.min(aComponents.length, bComponents.length)
		// loop while the components are equal
		if (a === b) {
			return 0
		} else {
			for (let i = 0; i < len; i++) {
				// A bigger than B
				if (parseInt(aComponents[i]) > parseInt(bComponents[i])) {
					return Math.pow(10, len - i)
				}
				// B bigger than A
				if (parseInt(aComponents[i]) < parseInt(bComponents[i])) {
					return -Math.pow(10, len - i)
				} else {
					if (i == len - 1) {
						return 0
					}
				}
			}
		}
	},
	deepen(obj: any) {
		const result = {}
		for (const objectPath in obj) {
			const parts = objectPath.split('.')
			let target: any = result
			while (parts.length > 1) {
				const part: any = parts.shift()
				target = target[part] = target[part] || {}
			}
			target[parts[0]] = obj[objectPath]
		}
		return result
	},

	dotify(obj: any) {
		const res: any = {}
		function recurse(obj: any, current: string = '') {
			for (const key in obj) {
				const value: any = obj[key]
				if (value != undefined) {
					const newKey: any = current ? current + '.' + key : key
					if (value && typeof value === 'object') {
						recurse(value, newKey)
					} else {
						res[newKey] = value
					}
				}
			}
		}
		recurse(obj)
		return res
	},

	µ2Date(unix: number | string, format: string = '') {
		if (typeof unix === 'string') unix = parseInt(unix)
		if ((unix + '').length <= 11) unix = unix * 1000
		// const dateFormat = THIS_YEAR_UNIXTS < unix ? 'DD.MMM HH:mm':'DD.MMM YYYY HH:mm'
		if (format == 'tooltip') {
			const fullDate: string = 'dd DD.MMMM YYYY HH:mm'
			return `${this.$dayjs(unix).format(fullDate)}\n(${this.$dayjs(unix).fromNow()})`
		} else {
			const dateFormat = THIS_YEAR_UNIXTS < unix ? 'DD.MMM HH:mm' : 'DD.MMM YYYY'
			return this.$dayjs(unix).format(dateFormat)
		}
	},

	average(arr: any) {
		return arr.reduce((a: number, b: number) => a + b, 0) / arr.length
	},
	roundFive(num: number | null) {
		return num !== null ? Math.round(num * 100000) / 100000 : null
	},
	roundToNextFivteen(num: number) {
		return Math.round(num / 15) * 15
	},
	aN(num: number | string | null) {
		return !isNaN(parseFloat(num + ''))
	}, // is a Number
	noNulls(nums: number[] | string[]) {
		return !nums.some((el: any) => el === null)
	},
	maxOfList(array: number[] = []) {
		return Math.max.apply(null, array)
	},
	minOfList(array: number[] = []) {
		return Math.min.apply(null, array)
	},
	isEmpty(object: any = {}) {
		return Object.keys(object).length === 0
	},
	// np(num: number) {
	// 	if (num) return parseFloat(num.toPrecision(5))
	// 	else return num
	// } // for precision
}
export default µUtils

export const waitFor = (ms: number) => new Promise((r) => setTimeout(r, ms))

export const splitToChunks = <T>(arr: T[], chunkSize: number): T[][] => {
	const chunks: T[][] = []
	let i = 0
	while (i < arr.length) chunks.push(arr.slice(i, (i += chunkSize)))
	return chunks
}

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}
